import "./Registration.scss";

import {
  Avatar,
  Step,
  StepConnector,
  StepContent,
  StepIconProps,
  StepLabel,
  Stepper,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ActiveStepper from "../../../../Assets/Registration/Active_stepper_icon.svg";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ADMIN_ROLES, ColorlibConnector, ColorlibStepIcon, I18_TRANSLATION_COMMON, LANGUAGES, LAYOUTS, NUMBER_CONSTANTS, ROUTES, STORAGE_KEYS } from "../../../Utilities/Constants/Constants";
import BasicInformation from "./BasicInformation/BasicInformation";
import { useEffect, useState } from "react";
import SelectRole from "./SelectRole/SelectRole";
import ProfessionalDetails from "./ProfessionalDetails/ProfessionalDetails";
import PersonalInformation from "./PersonalInformation/PersonalInformation";
import Verify from "./Verify/Verify";
import { GetSessionStorageData, SetSessionStorageData, clearSessionStorage, nullUndefinedEmptyCheck } from "../../../Services/Helpers/Helper";
import LanguageIcon from "@mui/icons-material/Language";
import { useDispatch, useSelector } from "react-redux";
import { setAwsData, setLanguage } from "../../../Services/Redux/Reducer/Reducer";
import { useTranslation } from "react-i18next";
import BankingInformation from "./BankingInformation/BankingInformation";
import { useNavigate } from "react-router-dom";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions";
import SchoolsUniversityBasicInformation from "./SchoolsUniversityBasicInformation/SchoolsUniversityBasicInformation";
import img from "../../../../Assets/sidebar/phygital_Logo.svg"
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";

const Registration = () => {
  const [activeStep, setActiveStep] = useState(NUMBER_CONSTANTS.ZERO);
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [roleId, setRoleId] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    getRoleId();
    // getAwsCredentials();
  }, []);

  useEffect(() => {
    if (roleId) {
      let status: any = GetSessionStorageData(STORAGE_KEYS.ACTIVE_STEP)
      setActiveStep(status ? parseInt(status) : NUMBER_CONSTANTS.ZERO);
    } else {
      // navigate(ROUTES.LOGIN)
    }

  }, [roleId])

  useEffect(() => {
    let email: any = GetSessionStorageData(STORAGE_KEYS.EMAIL)
    if (email == "" || email == null || email == undefined) {
      navigate(ROUTES.LOGIN)
    }
  }, [GetSessionStorageData(STORAGE_KEYS.EMAIL)])


  const getAwsCredentials = () => {
    axiosInstance.get(API_END_POINTS.AWS_CREDENTIALS_LIST).then((response: any) => {
      let payload = {
        accessKey: "",
        secretKey: ""
      }
      dispatch(
        setAwsData(
          response.data.result.data
        ))
    })
  }


  /* Getting Role ID from session storage*/
  const getRoleId = () => {
    let roleId: any = GetSessionStorageData(STORAGE_KEYS.ROLE);
    setRoleId(roleId);
  }

  /* Langugae change handling */
  const changeLanguage = (languageCode: string) => {
    dispatch(
      setLanguage(
        language === LANGUAGES.ENGLISH ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH
      )
    );
    i18n.changeLanguage(languageCode);
  };

  const dispatch = useDispatch();
  /* Getting langugae from store */
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  /* Handling active state */
  const setActiveStatus = (status: any) => {
    setActiveStep(status);
    SetSessionStorageData(STORAGE_KEYS.ACTIVE_STEP, status);
    getRoleId();
  };

  return (
    <div className="row registration-wrapper" dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}>
      <div className="row language_switch_header">

        <div className="language_switch_contianer">
          <div className="icon-wrapper">
            <img
              className="sidebar_logo_icon"
              src={img}
              alt="Learn and Play"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          </div>
          <div>
            <LanguageIcon className="language_icon" />
            <button
              className="language_button"
              onClick={() => {
                changeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC_ABBRIVATION
                    : LANGUAGES.ENGLISH_ABBRIVATION
                );
              }}
            >
              {language === LANGUAGES.ENGLISH
                ? LANGUAGES.ARABIC
                : LANGUAGES.ENGLISH}
            </button>
            {/* <Avatar alt="Admin" className="avatar" src={img} /> */}
            <button
              className="language_button logout-btn"
              onClick={() => {
                clearSessionStorage();
                navigate(ROUTES.DASHBOARD);
              }}
            >
              <ExitToAppIcon />Logout
            </button>
          </div>

        </div>

      </div>
      <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 registration-container">
        <div className="stepper-wrap">
          {activeStep !== 0 && <Stepper alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />} dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}>
            <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon} >Your Role</StepLabel>

            </Step>
            <Step key={"Basic Information"}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Basic Information</StepLabel>

            </Step>
            {(roleId === ADMIN_ROLES.TUTOR || roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Professional Details</StepLabel>

            </Step>}
            <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Personal Information</StepLabel>

            </Step>
            {(roleId === ADMIN_ROLES.TUTOR || roleId === ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Banking Information</StepLabel>

            </Step>}
            <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Terms & Conditions</StepLabel>

            </Step>
            <Step>
              <StepLabel StepIconComponent={ColorlibStepIcon}>Verify</StepLabel>

            </Step>
          </Stepper>}
        </div>

        {activeStep === 0 && <div className="child-wraps">
          <SelectRole activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreationa; step:1 */}
        {roleId && activeStep === 1 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <div className="child-wraps">
          <BasicInformation activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreational step:2 */}
        {activeStep === 2 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <div className="child-wraps">
          <ProfessionalDetails activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreational step:3 */}
        {activeStep === 3 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <div className="child-wraps">
          <PersonalInformation activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreational step:4 */}
        {roleId && activeStep === 4 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && activeStep === 4 && <div className="child-wraps">
          <BankingInformation activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreational step:5 */}
        {activeStep === 5 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <div className="child-wraps">
          <TermsAndConditions activeStatus={setActiveStatus} />
        </div>}

        {/* Tutor,Recreational step:5 */}
        {activeStep === 6 && (roleId === ADMIN_ROLES.TUTOR || roleId == ADMIN_ROLES.RECREATIONAL_PERSONAL || roleId === ADMIN_ROLES.RECREATIONAL_CAMP || roleId === ADMIN_ROLES.EDUCATIONAL_EXPERT) && <div className="child-wraps">
          <Verify activeStatus={setActiveStatus} />
        </div>}




        {/* School,university step:1 */}
        {roleId && activeStep === 1 && (roleId === ADMIN_ROLES.SCHOOL || roleId === ADMIN_ROLES.UNIVERSITY) && <div className="child-wraps">
          <SchoolsUniversityBasicInformation activeStatus={setActiveStatus} />
        </div>}

        {/* School,university step:2 */}
        {activeStep === 2 && (roleId === ADMIN_ROLES.SCHOOL || roleId === ADMIN_ROLES.UNIVERSITY) && <div className="child-wraps">
          <PersonalInformation activeStatus={setActiveStatus} />
        </div>}


        {/* School,university step:3 */}
        {activeStep === 3 && (roleId === ADMIN_ROLES.SCHOOL || roleId === ADMIN_ROLES.UNIVERSITY) && <div className="child-wraps">
          <TermsAndConditions activeStatus={setActiveStatus} />
        </div>}

        {/* School,university step:4 */}
        {activeStep === 4 && (roleId === ADMIN_ROLES.SCHOOL || roleId === ADMIN_ROLES.UNIVERSITY) && <div className="child-wraps">
          <Verify activeStatus={setActiveStatus} />
        </div>}

      </div>
    </div>
  );
};

export default Registration;
